<template>
  <div v-if="showModal" class="CookieModalWrapper">
    <div class="CookieModal">
      <button @click="closeModal" class="CloseButton">×</button>
      <h2 class="CookieModalTitle">{{ $t("cookieModal.title") }}</h2>
      <p class="CookieModalText">
        {{ $t("cookieModal.text") }}
        <a
          href="/docs/cookie.pdf"
          class="CookieModalLink"
          target="_blank"
          rel="noopener noreferrer"
          @click="closeModal"
        >
          {{ $t("cookieModal.linkText") }}
        </a>
      </p>
      <div class="CookieModalButtons">
        <button @click="rejectCookies" class="RejectButton">
          {{ $t("cookieModal.reject") }}
        </button>
        <button @click="acceptCookies" class="AcceptButton">
          {{ $t("cookieModal.accept") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieModal",
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    checkCookieConsent() {
      const consent = localStorage.getItem("cookieConsent");
      if (!consent) {
        this.showModal = true;
      }
    },
    acceptCookies() {
      localStorage.setItem("cookieConsent", "accepted");
      this.showModal = false;
    },
    rejectCookies() {
      localStorage.setItem("cookieConsent", "rejected");
      this.showModal = false;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.CookieModalWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2000;
}

.CookieModal {
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: 20px;
}

.CloseButton {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  color: #666666;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.CloseButton:hover {
  color: #000000;
}

.CookieModalTitle {
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 16px 0;
  padding-right: 32px;
}

.CookieModalText {
  font-size: 14px;
  line-height: 1.5;
  color: #333333;
  margin: 0 0 24px 0;
  text-align: left;
}

.CookieModalLink {
  color: #ff6b35;
  text-decoration: underline;
  cursor: pointer;
}

.CookieModalLink:hover {
  color: #e55a2b;
}

.CookieModalButtons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.RejectButton {
  padding: 10px 20px;
  background: #ffffff;
  border: 1px solid #ff6b35;
  color: #ff6b35;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.RejectButton:hover {
  background: #fff5f2;
}

.AcceptButton {
  padding: 10px 20px;
  background: #ff6b35;
  border: 1px solid #ff6b35;
  color: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.AcceptButton:hover {
  background: #e55a2b;
  border-color: #e55a2b;
}

@media (max-width: 600px) {
  .CookieModal {
    padding: 24px;
  }

  .CookieModalButtons {
    flex-direction: column;
  }

  .RejectButton,
  .AcceptButton {
    width: 100%;
  }
}
</style>
